import http from "../http";

export async function getCountryCodes() {
  const response = await http.get("/country/codes/");
  return response.data;
}
